import { colors } from '@alixpartners/ui-components';
import styled, { css } from 'styled-components';
const NON_STANDARD_GRAY = '#F2F2F2';

const addBackgroundColor = css`
	background-color: ${colors.grey300};
`;

export const Wrapper = styled.div`
	background-color: ${colors.grey1};
	height: 100%;
	overflow-y: scroll;
`;

export const KpiGridContainer = styled.div`
	display: flex;
`;

export const Ribbon = styled.div`
	background-color: ${colors.white};
	display: flex;
	flex-direction: row;
	align-items: center;
	border-bottom: 1px solid ${colors.grey3};
	height: 40px;
	box-sizing: border-box;
	position: sticky;
	top: 0;
	z-index: 1;
`;

export const RibbonText = styled.div`
	font-size: 17px;
	font-weight: 600;
	letter-spacing: 0.3px;
	cursor: pointer;
	color: ${colors.grey6};
`;

export const ContentLoader = styled.div`
	padding: 5%;
	margin: auto;
`;

export const TableWrapper = styled.div`
	width: 100%;
	overflow: clip scroll;

	.ag-theme-balham {
		width: 100%;
		font-family: 'Roboto';

		.ag-root,
		.ag-side-bar,
		.ag-root-wrapper,
		.ag-status-bar {
			border: none;
		}

		.ag-header-row {
			border-bottom: 0px;
		}

		.ag-header {
			background-color: transparent;
			border: none;
			color: ${colors.grey5};
		}

		.ag-header-cell {
			font-weight: normal;
			font-size: 11px;
			line-height: 13px;
			letter-spacing: 0.8px;
			padding-bottom: 5px;
			font-family: 'Roboto';

			.ag-header-cell-text {
				white-space: pre-line;
			}

			&.ag-numeric-header {
				text-align: right;
			}

			&::after {
				display: none;
			}
		}

		.ag-row {
			background-color: transparent;
			border-color: ${colors.grey3};

			&.ag-row-last {
				border-bottom: none;
			}

			.ag-cell {
				font-size: 13px;
				font-weight: normal;
				line-height: 24px;
				letter-spacing: 0.3px;
				color: ${colors.grey5};
			}
		}

		.ag-floating-top-viewport {
			border: none;
		}

		.ag-floating-top {
			border-color: ${colors.grey3};
		}

		.ag-row-pinned {
			border: none;

			&.ag-row-last {
				border: none;
			}

			.ag-cell {
				font-weight: bold;
			}
		}

		.ag-header-row-column {
			border-bottom: 1px solid ${colors.grey3};
		}
	}
`;

export const CardTypesWrapper = styled.div`
	padding: 5px 0px 0px;
	display: flex;
	flex-direction: column;
	justify-content: space-evenly;
	align-items: center;
`;

export const CardTypeOptionWrapper = styled.div`
	width: 50%;
	margin: 2%;
	${props => props.isSelected && addBackgroundColor};
`;

export const CardTypeOptionButton = styled.button`
	border: none;
	text-align: center;
	width: 100%;
	cursor: pointer;
	transition: all 0.3s ease-in-out;
	&:hover {
		background: ${colors.grey300};
		color: ${colors.black};
	}
`;

export const IconWrapper = styled.div``;

export const Heading = styled.div`
	font-size: 13px;
	font-weight: 400;
	color: ${colors.black};
`;

export const DirectIndirectOptionsWrapper = styled.div`
	margin: 0 15px 0 auto;
	button {
		span {
			text-transform: capitalize;
		}
	}
`;

export const SourceableTotalSpendOptionWrapper = styled.div`
	margin: 0 15px 0 0;
	button {
		span {
			text-transform: capitalize;
		}
	}
`;

export const TaxonomyTypeOptionWrapper = styled.div`
	margin: 0 15px 0 0;
	button {
		span {
			text-transform: capitalize;
		}
	}
`;

export const DateRangeWrapper = styled.div`
	.ap-month-picker > div:nth-child(2) {
		top: 95%;
		right: 11%;
	}
`;

export const NoDataWrapper = styled.div`
	height: 620px;
	background-color: ${NON_STANDARD_GRAY};
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: space-around;
	position: relative;
`;
